<template>
<!-- https://img.chinabeego.com/uploadfile/2021/8/27/163004657837119015466468985833.png -->
  <div class="zon">
    <div v-if="!loading && !networkFakShow">
      <div class="nav-bg"></div>
      <ul class="div-cont mr-b-100">
        <!-- 主订单详情不显示这一列 -->
        <li>
          <DetailBComp
            :isVirtual="isVirtual"
            :createTimeLong="info.createTimeLong || ''"
            :needPayString="info.mainOrderLabel == '待确认' ? needPayForJs : info.actualPrice || ''"
            :status="info.appSubOrderDetailVoList[0].orderStatus"
            :subId="info.appSubOrderDetailVoList[0].id"
            :orderDetails="info.appSubOrderDetailVoList[0]"
            :payTime="info.payTime"
            :orderType="info.orderType"
          ></DetailBComp>
        </li>
        <li>
          <!-- 待付款状态快速订单下才可以改变默认地址 -->
          <DetailCComp
            :orderDetails="info.appSubOrderDetailVoList[0]"
            v-if="!isVirtual && info.appSubOrderDetailVoList[0].orderStatus != 'CANCEL_TIMEOUT' && info.appSubOrderDetailVoList[0].orderStatus !='CANCEL_USER' && (info.appSubOrderDetailVoList[0].contentCouponType != 2 )"
            :addAdressVisible="info.needPay == '1' && info.orderType == 'QUICK_ORDER' && info.appSubOrderDetailVoList[0].isAllowModifyReceiverAddress == 'y'"
            :subId="subId"
            :addressInfo="info.orderType == 'QUICK_ORDER' && info.needPay == '1' ? {userName:addressInfo.userName, mobile:addressInfo.mobile, adress:addressInfo.adress,addressId:addressInfo.id} : {userName:info.appSubOrderDetailVoList[0].receiverName, mobile:info.appSubOrderDetailVoList[0].receiverPhone, adress:info.appSubOrderDetailVoList[0].receiverAddress}"
          ></DetailCComp>
        </li>
        <li>
          <DetailNormalComp
            v-if="info.orderType == 'NORMAL_ORDER'"
            :orderItem="info.appSubOrderDetailVoList"
            :orderDetailType="orderDetailType"
            :isAfterBybees="isAfterBybees"
            :isUser="isUser"
          ></DetailNormalComp>
          <DetailQuickComp
            v-if="info.orderType == 'QUICK_ORDER'"
            :orderItem="info.appSubOrderDetailVoList"
            ref="DetailQuickComp"
          ></DetailQuickComp>
        </li>
        <zengDetailNormal
            v-if="info.orderType == 'NORMAL_ORDER'"
            :orderItem="info.giftSubOrderDetailVoList"
            :orderDetailType="orderDetailType"
            :isAfterBybees="isAfterBybees"
            :isUser="isUser"
          ></zengDetailNormal>
        <div class="goods-tip" v-show="isVirtual">
          <div><span class="goods-tip-title">温馨提示：</span>订单已完成，优惠券已发放到你的账户，可点击“查看券码”或到“{{info.skinModuleDesc}}”-“优惠券”中查看。</div>
        </div>
        <li v-if="tips">
          <div class="yiqing">{{tips}}</div>
        </li>
        
        <!-- 已经完成 可开具发票 -->
        <li v-if="info.appSubOrderDetailVoList[0].orderStatus == 'COMPLETED'  && info.appSubOrderDetailVoList[0].invoiceStatus != -1">
          <div class="invoice">
            <span class="label">电子发票</span>
            <span @click="invoiceStatusClick">{{invoiceStatusData[info.appSubOrderDetailVoList[0].invoiceStatus]}}</span>
            <van-icon class="arrow-right" name="arrow"/>
          </div>
          <!-- <div class="invoice" v-if="'1,2,3'.includes(info.appSubOrderDetailVoList[0].invoiceStatus)">
            <span class="label">申请时间</span>
            <span style="color:#3B3A38;">{{info.appSubOrderDetailVoList[0].invoiceCreateTime}}</span>
          </div>
          <div class="invoice" v-if="'2,3'.includes(info.appSubOrderDetailVoList[0].invoiceStatus)">
            <span class="label">开票时间</span>
            <span style="color:#3B3A38;">{{info.appSubOrderDetailVoList[0].markDate}}</span>
          </div> -->
        </li>

        <li>
          <div class="tips-info" v-if="info.appSubOrderDetailVoList[0].giftFlag == 1 && info.appSubOrderDetailVoList[0].contentCouponType == 2">
            <div class="name">温馨提示</div>
            <div>赠送券包将在活动商品{{info.appSubOrderDetailVoList[0].giftGiveNode }}后，自动发放至您的账户当中。</div>
          </div>
        </li>

        <li>
          <DetailDComp
            :isVirtual="isVirtual"
            :deInfo="info"
            :orderId="orderId"
            :yunfeiPay="yunfeiPay"
            :couponValue="couponValue"
            :defaultFrightCouponValue="defaultFrightCouponValue"
            :needPayString="info.mainOrderLabel == '待确认' ? needPayForJs : info.actualPrice || ''"
          ></DetailDComp>
        </li>
      </ul>
      <div class="index-order-bottom">
        <mixedRecoListdata ref="mixedReco" :headerStatus="true" :showStatus="true" :mixedRecoParams="mixedRecoParams"></mixedRecoListdata>
      </div>
      <div class="footer-box" >
        <div class="footer van-hairline--top">
          <button-group v-show="!isVirtual" align="right">
            <ContactComp
              v-if="info.orderType == 'QUICK_ORDER'"
              :role="'user'"
              :contactId="info.appSubOrderDetailVoList[0].shopId"
              :couponPackageId="info.appSubOrderDetailVoList[0].appSubOrderItemDetailVoList[0].couponPackageId"
            ></ContactComp>

            <!-- 已取消 超时关闭 -->
            <BuyAgainComp
              v-if="orderId && info.appSubOrderDetailVoList[0].orderStatus == 'CANCEL_TIMEOUT' && info.orderType != 'QUICK_ORDER' && info.appSubOrderDetailVoList[0].giftFlag != 1"
              :goodList="formatAgainList"
            ></BuyAgainComp>
            <!-- 已取消 超时关闭 end-->

            <!-- 待付款 -->
            <CancelComp
              v-if="info.needPay == '1'&& info.orderType != 'ADJUST_ORDER'"
              :id="info.id"
              title="cancel"
              @callbackFun="init"
            ></CancelComp>
            <WaitPayComp
              v-if="info.needPay == '1' && info.orderType != 'ADJUST_ORDER'"
              showType="button"
              :needPayString="info.actualPrice"
              :createTimeLong="info.createTimeLong"
              :orderId="info.id"
              :orderItem="info"
              :orderType="info.orderType"
              :count="info.appSubOrderDetailVoList[0].count"
              :isAllowModifyReceiverAddress="info.appSubOrderDetailVoList[0].isAllowModifyReceiverAddress || ''"
              :userCouponId="userCouponId"
              :defaultFrightCouponId="defaultFrightCouponId"
            ></WaitPayComp>
            <!-- 待付款 end-->

            <!-- 待补款 -->
            <div v-if="info.needPay == '1' && info.orderType == 'ADJUST_ORDER'">
              <van-button class="button-active" size="small" round plain normal hairline @click="goBuPeice(info.id)">待补款</van-button>
            </div>
            <!-- 待补款 end-->

            <!-- 待发货 -->
            <CancelComp
              v-if="info.appSubOrderDetailVoList[0].orderStatus == 'WAIT_SEND' && info.appSubOrderDetailVoList[0].isAllowOrderAfter == 'y'"
              :id="info.appSubOrderDetailVoList[0].id"
              :isAfterByBees="info.appSubOrderDetailVoList[0].isAfterByBees"
              title="outmoney"
              @callbackFun="init"
            ></CancelComp>
            <!-- <div v-if="info.appSubOrderDetailVoList[0].orderStatus == 'WAIT_SEND' && info.appSubOrderDetailVoList[0].isAllowOrderAfter == 'n' && info.appSubOrderDetailVoList[0].orderAfterId">
              <van-button @click="afterDetail" size="small" round plain normal hairline>退款中</van-button>
            </div> -->
            <div v-if="info.appSubOrderDetailVoList[0].orderStatus == 'WAIT_SEND'">
              <van-button 
                v-if="info.appSubOrderDetailVoList[0].haveUrgeButton && info.appSubOrderDetailVoList[0].isAllowOrderAfter == 'y'"
                :class="{'clearBtn':info.appSubOrderDetailVoList[0].haveUrgeButton==2}"
                size="small"
                plain
                round
                normal
                hairline
                @click="urgeDeliveryFun"
              >催发货</van-button>
            </div>
            <!-- 待发货 end-->

            <!-- 待收货 -->
            <div v-if="info.appSubOrderDetailVoList[0].orderStatus == 'WAIT_RECEIVING' && info.appSubOrderDetailVoList[0].dispatchType != 5">
              <van-button @click="checkWL(info)" size="small" round plain normal hairline>查看物流</van-button>
            </div>
            <SuerGoodsComp
              v-if="info.appSubOrderDetailVoList[0].orderStatus == 'WAIT_RECEIVING'"
              :subId="info.appSubOrderDetailVoList[0].id"
              :item="info.appSubOrderDetailVoList[0]"
              @callBackFun="init"
            ></SuerGoodsComp>
            <!-- 待收货 end-->

            <!-- 已完成 -->
            <BuyAgainComp
              v-if="info.appSubOrderDetailVoList[0].orderStatus == 'COMPLETED' && info.orderType != 'QUICK_ORDER' && info.appSubOrderDetailVoList[0].giftFlag != 1"
              :goodList="info.appSubOrderDetailVoList[0].appSubOrderItemDetailVoList"
            ></BuyAgainComp>
            <!-- 已完成 end-->
          </button-group>
          <!-- 虚拟商品除了付款没有其他操作 -->
          <button-group v-show="isVirtual && info.needPay == '1'" align="right">
            <CancelComp
              :id="info.id"
              title="cancel"
              @callbackFun="init"
            ></CancelComp>
            <WaitPayComp
              showType="button"
              :needPayString="info.actualPrice"
              :createTimeLong="info.createTimeLong"
              :orderId="info.id"
              :orderType="info.orderType"
              :count="info.appSubOrderDetailVoList[0].count"
              :isAllowModifyReceiverAddress="info.appSubOrderDetailVoList[0].isAllowModifyReceiverAddress || ''"
              :userCouponId="userCouponId"
              :defaultFrightCouponId="defaultFrightCouponId"
            ></WaitPayComp>
          </button-group>
        </div>
      </div>
    </div>
    <div v-if="networkFakShow" class="network-fak">
      <div v-show="networkFakShow_fail">
        <div class="view1">
          <img :src="$theme.u_errornet_icon_default || imgFail" alt="">
        </div>
        <div class="view2">加载错误</div>
        <div class="view3">很抱歉您访问的页面出错啦</div>
        <div class="view4">
          <div class="view ve2">
            <button class="bt2" @click="goHomePage">返回首页</button>
          </div>
          <div class="view ve1">
            <button class="bt1" @click="init">刷新试试</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/utils/axios";
import Util from "@/utils/common";
import utils from "@/utils/common";
import DetailAComp from "./components/detailA";
import DetailBComp from "./components/detailB";
import DetailCComp from "./components/detailC";
import DetailQuickComp from "./components/detailQuick";
import DetailNormalComp from "./components/detailNormal";
import zengDetailNormal from "./components/zengDetailNormal";
import DetailDComp from "./components/detailD";
import ContactComp from "./components/contactComp";
import CancelComp from "./components/cancelComp";
import WaitPayComp from "./components/waitPay";
import BuyAgainComp from "./components/buyAgain";
import SuerGoodsComp from "./components/sureGoods";
import mixedRecoListdata from '@/components/mixedReco/mixedRecoListdata';
import ButtonGroup from './components/buttonGroup'

export default {
  data() {
    return {
      orderDetailType:"",   //订单详情类型: 主订单类型(未付款)/ 子订单类型(已付款..)    ver0321
      orderId: this.$route.query.orderId || "",
      subId: this.$route.query.subId || "",
      targetParams: this.$route.query.targetParams || "", //从app端信息推送到此界面
      loading: false,
      isUser:true,
      info: {
        actualPrice: 0,
        appSubOrderDetailVoList: [{}],
        createTime: "",
        createTimeLong: 0,
        id: 0,
        mainOrderLabel: "",
        needPay: 0,
        orderCode: "",
        orderTime: "",
        orderType: "",
        payTime: "",
        // goodList: [],
        isOrderAfter: "y",
        orderStatus: ""
      },
      deInfo: {},
      sendLoading: false,
      formatAgainList: [],
      yunfeiPay: 0,
      addressInfo: {
        userName: "",
        mobile: "",
        adress: "",
        id: ""
      },
      userCouponId: "",
      couponValue: 0,
      tips: "",
      defaultFrightCouponId:"",
      defaultFrightCouponValue:"",
      needPayForJs:0,
      mixedRecoParams: {},
      eqInfoList:[],
      isVirtual: false, //是否是虚拟商品
      isAfterBybees: false,  // 是否有员工端发起的售后
      imgFail: require('@/assets/nw_fa02.png'),
      networkFakShow: false,
      networkFakShow_fail: false,
      networkFakShow_none: false,
      // invoiceStatusData:{ 0:'未开票', 1:'部分开票', 2:'已开票', 3:'已开票' }
      invoiceStatusData:{ 0:'申请开票', 1:'开票中', 2:'查看发票', 3:'开票失败' }
    };
  },
  methods: {
    invoiceStatusClick(){
      if('0,3'.includes(this.info.appSubOrderDetailVoList[0].invoiceStatus)){
        console.log('跳转小程序');
        utils.nativeMethod({ tm: 4000104, tp: { path: `market/pages/invoice-apply/index?subId=${this.subId}` } })
      }else{
        this.$router.push({
          name: "userInvoiceDetail",
          query:{
            subOrderId:this.subId
          }
        });
      }
    },
    urgeDeliveryFun(){
      if(this.info.appSubOrderDetailVoList && this.info.appSubOrderDetailVoList[0].haveUrgeButto ==2){
        this.$toast('我们已经将您的请求告知店铺，还请您耐心等待');
        return
      }
      this.http({
        url:'order/urge/urgeDelivery',
        method:'post',
        parmes:{
          subOrderId:this.subId
        }
      }).then(rps=>{
        if(rps.code==200){
          this.$toast(rps.data);
          return;
        }
      })
    },
    init() {
      this.loading = true;
      this.networkFakShow= false;
      this.networkFakShow_none= false;
      this.networkFakShow_fail= false;
      let url = "",
        param = {};
      this.orderId && (url = "order/appOrder/user/mainOrderDetail");
      this.subId && (url = "order/appOrder/user/subOrderDetail");
      this.orderId && (param = { orderId: this.orderId });
      this.subId && (param = { subOrderId: this.subId });
      //订单详情类型: 主订单类型(未付款)/ 子订单类型(已付款..)  ver0321
      console.log("this.subId--订单详情类型--ver0321--",this.subId);
      if(this.subId){
        this.$set(this,"orderDetailType","subOrderDetail")
      }
      http({
        url: url,
        method: "post",
        parmes: param
      }).then(rps => {
        this.loading = false;
        // console.log('rps.data',rps.data)
        if(rps.code === 200){
          this.info = JSON.parse(JSON.stringify(rps.data));
          if (this.orderId) {
            //格式化针对主订单详情再次购买的值
            let formatAgain = rps.data.appSubOrderDetailVoList.map(item => {
              return item.appSubOrderItemDetailVoList;
            });
            formatAgain.forEach(element => {
              element.forEach(item => {
                this.formatAgainList.push(item);
              });
            });
  
            (this.addressInfo.userName =
              rps.data.appSubOrderDetailVoList[0].receiverName || ""),
              (this.addressInfo.mobile =
                rps.data.appSubOrderDetailVoList[0].receiverPhone || ""),
              (this.addressInfo.adress =
                rps.data.appSubOrderDetailVoList[0].receiverAddress || "");
  
            //console.log(this.formatAgainList);
            //查看有无默认优惠券
            if (rps.data.needPay == "1" && rps.data.mainOrderLabel == "待确认") {
              this.getCouponList(rps.data.id);
            }
          }
          //针对快速订单计算运费
          if (
            this.info.appSubOrderDetailVoList[0].isAllowModifyReceiverAddress ==
            "y"
          ) {
            this.getAddressList();
          }
          this.mixedRecoParams = rps.data.recommends ? rps.data.recommends : {}
  
          // 判断是否有虚拟商品
          this.isVirtual = rps.data.appSubOrderDetailVoList[0].appSubOrderItemDetailVoList.some((row)=> {return row.isVirtual == 'y'})

          // 判断是否有员工端发起的售后 true: 有   false: 没有
          this.isAfterBybees = rps.data.appSubOrderDetailVoList[0].appSubOrderItemDetailVoList.some((row)=> {return row.isAfterBybees})
          // this.isAfterBybees = rps.data.appSubOrderDetailVoList[0].appSubOrderItemDetailVoList.some((row)=> {return row.isAllowOrderAfter == 'n'})
          console.log(this.isAfterBybees, 333);
        }else{
          if(rps.code === 503){
            this.networkFakShow= true;
            this.networkFakShow_fail= true;
          }
        }
      }).catch((res) =>{
      })
    },
    checkWL(item) {
      let data = item.appSubOrderDetailVoList[0];
      let row = data.appSubOrderItemDetailVoList[0];
      this.$store.dispatch('setExpressObjData',{
        subOrderCode: data.subOrderCode,
        payTime: item.payTime,
        imgUrl: row.skuImageInfoUrlList[0] || ''
      });
      this.$router.push({name: "userExpress",query: {subid: data.id}});
    },
    getAddressList() {
      http({
        url: "base/user/address/findDefault",
        method: "post",
        parmes: {}
      }).then(rps => {
        this.addressInfo.adress = rps.data.areaName + rps.data.addressDetail;
        this.addressInfo.userName = rps.data.userName;
        this.addressInfo.mobile = rps.data.mobile;
        this.addressInfo.id = rps.data.id;
        this.getFrightPrice(rps.data.id);
        //console.log(this.addressInfo);
      });
    },
    getFrightPrice(userAddressId) {
      let arr = [];
      let frightWeight = this.info.appSubOrderDetailVoList[0].frightWeight;
      this.info.appSubOrderDetailVoList[0].appSubOrderItemDetailVoList.forEach(
        element => {
          arr.push({
            count: element.goodsCount,
            frightCount: this.info.frightCount,
            goodId: element.goodsId,
            userAddressId: userAddressId,
            weight: frightWeight
          });
        }
      );
      this.doFrightPrice(arr);
    },
    doFrightPrice(parmesArr) {
      http({
        url: "order/app/find/fright",
        method: "post",
        parmes: parmesArr
      }).then(rps => {
        this.yunfeiPay = rps.data;
      });
    },
    afterDetail() {
      this.$router.push({
        name: "userAfterOrderDetail",
        query: { afterId: this.info.appSubOrderDetailVoList[0].orderAfterId }
      });
    },
    getCouponList(mainOrderId) {
      let parms = {
        goodsList: [],
        mainOrderId: mainOrderId
      };
      http({
        url: "order/coupon/getUserOwnCoupon",
        method: "post",
        parmes: parms
      }).then(rps => {
        if (rps.data.defaultCoupon && rps.data.defaultCoupon.couponId) {
          this.userCouponId = rps.data.defaultCoupon.userCouponId;
          this.couponValue = rps.data.defaultCoupon.couponValue;
        }
        if (rps.data.defaultFrightCoupon && rps.data.defaultFrightCoupon.userCouponId) {
          this.defaultFrightCouponId = rps.data.defaultFrightCoupon.userCouponId;
          this.defaultFrightCouponValue = rps.data.defaultFrightCoupon.couponValue;
        }

        //如果 总运费<运费券 需要付款(抵消掉了运费) = 原始价格 - 优惠券价格
        if(this.yunfeiPay <= this.defaultFrightCouponValue){
          this.needPayForJs = (this.info.actualPrice  - this.couponValue).toFixed(2);
        }else{
          //否则 实际给的运费 = 总运费 - 运费券的金额
          let temp = this.yunfeiPay - this.defaultFrightCouponValue;
          this.needPayForJs = (this.info.actualPrice + temp - this.couponValue).toFixed(2);
        }
        //console.log(this.needPayForJs)
      });
    },
    tipRequery() {
      http({
        url: "order/notice/order/prompt?orderCode=",
        method: "GET"
      }).then(rps => {
        if (rps.code === 200) {
          this.tips = rps.data;
        }
      });
    },
    goBuPeice(id){
      Util.callPay(id)
    },
    goHomePage(){
      Util.backToHome();
    },
  },
  created() {
    if (this.targetParams) {
      let target = JSON.parse(this.targetParams);
      this.orderId = (target.orderId && target.orderId) || "";
      this.subId = (target.subId && target.subId) || "";
      this.init();
    } else {
      this.init();
    }
    this.tipRequery();
    this.$loading.hide();
    Util.nativeMethod({tm:'4000102',tp:{pageType_pvar:'订单详情'}})
    Util.nativeMethod({tm:'4000102',tp:{pageName_pvar:document.title}})
    this.$refs.mixedReco && this.$refs.mixedReco.onGetMixedRecoData();
  },
  components: {
    DetailAComp,
    DetailBComp,
    DetailCComp,
    DetailQuickComp,
    DetailNormalComp,
    zengDetailNormal,
    DetailDComp,
    ContactComp,
    CancelComp,
    WaitPayComp,
    BuyAgainComp,
    SuerGoodsComp,
    ButtonGroup,
    mixedRecoListdata
  },
  watch:{
    'loading'(val,oldval){
      val ?  Util.nativeMethod({tm:'1000007',tp:{lock: true}}) : Util.nativeMethod({tm:'1000008',tp:{}})
    },
  },
};
</script>
<style lang="less" scoped>
.tips-info{
  background:#FEF6F0;
  font-size:24px;
  color: #F08E3C;
  border-radius: 8px;
  padding: 24px;
  margin-top: 24px;
}
.tips-info .name{
  font-size: 26px;
  margin-bottom:16px ;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  z-index: 1000;
}
.zon {
  position: relative;
  .nav-bg {
    background-image: url('https://img.chinabeego.com/uploadfile/2021/8/27/163005204499719021013089996163.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 100%;
    height: 136px;
  }
}
.div-cont {
  margin: -92px 30px 0;
  li {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.footer-box {
  height: 100px;
}
.footer {
  background-color: #fff;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  padding: 13px 30px 13px 20px;
  &::after {
    border-color: #F2F2F2;
  }
}
.btn-send {
  background: #fff;
  width: 100%;
  height: 104px;
  line-height: 104px;
  padding: 16px 0 0 0;
  text-align: center;
  font-size: 26px;
  .btn {
    background-color: #f8d541;
    height: 88px;
    line-height: 88px;
    border-radius: 0.5rem;
    width: 80%;
    margin-left: 10%;
  }
}

.clearBtn{
  background: #ccc !important;
  color: #999 !important;
}

.yiqing {
  font-size: 24px;
  border-radius: 0.15rem;
  background-color: #fff;
  padding: 40px;
  text-align: left;
}
.invoice {
  font-size: 24px;
  border-radius: 0.15rem;
  background-color: #fff;
  padding: 20px;
  text-align: left;
  display: flex;
  color: #4487DF;
}
.invoice .label {
  flex:1;
  font-size: 28px;
  color: #3B3A38;
}
.invoice .arrow-right {
  top: 6px;
  margin-left: 8px;
}

.liu0{
  border-top-left-radius:20px;
  border-top-right-radius:20px;
  padding-left: 40px;
  padding-top: 31px;
  display: flex;
  background-color: #fff;
  font-size: 24px;
  border: 1PX solid #F2F2F2;
  .liu1{
    color: #333333;
    margin-right: 46px;
  }
  .liu2{
    color:#999999;
    width: 478px;
    margin-bottom: 25px;
  }
}
.network-fak{
  /* height: 100vh; */
  background: #F7F7F7;
  justify-items: center;
  text-align: center;
  padding-top: 309px;
}
.network-fak .view1 img{
  width: 292px;
  height: 231px;
}
.network-fak .view2{
  font-size: 32px;
  color: #666666;
  margin-top: 34px;
}
.network-fak .view3{
  font-size: 24px;
  color: #999999;
  margin-top: 10px;
}
.network-fak .view4{
  margin-top: 30px;
  display: flex;
  justify-content:center;
}
.network-fak .view{
  display: inline-flex;
  height: 64px;
  line-height: 64px;
}
.network-fak .view4 .ve1{
  justify-items: left;
}
.network-fak .view4 .ve2{
  justify-items: right;
}
.network-fak .view4 button{
  width: 238px;
  border-radius: 32px;
  font-size: 24px;
}
.network-fak .view4 .bt1{
  color: #333333;
  background: #F8D541;
  border: 1px solid #F8D541;
  margin-left: 6px;
}
.network-fak .view4 .bt2{
  color: #999999;
  background: #fff;
  border: 1px solid #999999;
  margin-right: 6px;
}
.goods-tip{
    padding: 20px 30px;
    background-color: white;
    border-radius: 20px;
    font-size: 24px;
    color: #333333;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    margin-bottom: 20px;
}
.goods-tip-title{
  color: #F8A651;
}
</style>  